import { EnvironmentInjector, inject } from '@angular/core';

export class AppInjector {
  static injector: EnvironmentInjector;
}
